import type { FaireProductEntity } from "../../entity_types/product";

export const p_f8wqg39g46: FaireProductEntity = {
  token: "p_f8wqg39g46",
  type: "product",
  name: "Glitter Heart Tutu Skirt - Kids Clothes -Valentine",
  brandToken: "b_gro99lye",
  brandName: "Sweet Wink",
  imageUrl:
    "https://cdn.faire.com/fastly/5838f702674e193f74c1c177f3a52a82d9bf1e906230724448a1feaed729ca0e.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/7c4a722817e932cc7a98d852595349b05708c49a080edf7824fd9aa7de1500b1.jpeg",
    "https://cdn.faire.com/fastly/aa139bc45c7b233e55b70f6b211a7203f19fc26a418620d95bb0e624b3282b90.jpeg",
    "https://cdn.faire.com/fastly/7f505b46c34af12dc9815d15f0bd1d8e1781bbc6bee578e3c5e94327545d6da4.jpeg",
    "https://cdn.faire.com/fastly/f73f6d9a501a49df30e6199ad0618098610eab622c8e52e5fa0da29d0075a4b3.jpeg",
    "https://cdn.faire.com/fastly/be0c73ecee6ae183fb5714dee8126d9e88323a2e3f8ee7529ead013e04e199ae.jpeg",
  ],
  priceDollars: 18,
  description:
    "The Glitter Heart Tutu Skirt is a fun skirt and dress up tutu for celebrating Valentine's Day!\n\nFeatures:\n*White tulle accented with pink and silver glitter hearts\n*Pink cotton lining\n*Silver glitter waistband\n*Care: Hand wash and line dry\n\nThe Sweet Wink difference:\n*Super soft tulle that doesn’t scratch or itch\n*Cotton lining provides extra coverage and comfort\n*“Shed-free” embellishments ensure glitter does not sprinkle around the house",
  tags: [],
  msrpDollars: 36,
  inStock: false,
  meta: {
    source: "api",
    importedAt: "2026-08-12T07:01:29.507Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
